module.exports = __webpack_public_path__ + "assets/images/isi_pause_tablet.png";